var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrenchSouthernTerritories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b2364",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 0h4v10H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M8 0h4v10H8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 0v11H0v-1h12V0zm10.96 12.1-1.7 2.63V9.96h2.27l.84-.96H17.6l.84.96h2.27v4.76l-1.7-2.63-2.48 3.87h1.24L19 13.93l2.48 4.35 2.47-4.35 1.24 2.03h1.24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 11h3.13l-.69.95H21zm-3.22 4.02h2.47v.62h-2.47zm4.95 0h2.47v.62h-2.47zm-1.24 4.19.3 1.02h1.03l-.81.66.3 1.02-.82-.62-.82.6.3-1-.81-.66h1zM16.15 10l.3 1.03h1.03l-.81.63.3 1-.82-.63-.81.6.3-.97-.82-.63h1zm10.67 0 .3 1.03h1.04l-.82.63.3 1-.82-.63-.8.6.29-.97-.82-.63h1.01zm-8.26 7.15.3 1.03h1.03l-.81.64.3 1-.82-.62-.82.6.3-.98-.81-.64h1zm5.86 0 .3 1.03h1.03l-.82.64.3 1-.81-.62-.82.6.3-.98-.81-.64h1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrenchSouthernTerritories);
export default __webpack_public_path__ + "static/media/french-southern-territories.779592cdf61d6990ab08853e13f2501a.svg";
export { ForwardRef as ReactComponent };